import { Header } from "./Header";
import { Hero } from "./Hero";
import { Marquee } from "./Marquee";
import { Problems } from "./Problems";
import { HowItWorks } from "./HowItWorks";
import { Compounding } from "./Compounding";
import { WhatItIs } from "./WhatItIs";
import { Waitlist } from "./Waitlist";
import { Footer } from "./Footer";

export const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Problems />
      <HowItWorks />
      <Compounding />
      <WhatItIs />
      <Waitlist />
    </main>
    <Footer />
  </>
);
